/** Page history: the last 20 draft snapshots (one per 5 minutes of editing); restoring puts one back into the draft. */
import React, { useEffect, useState } from 'react';
import { Button, Drawer, Empty, List, Modal, Spin, Tag, Typography, message } from 'antd';
import { useTranslation } from '../../../shared/i18n';
import { fmtDate, toastErr, useSite } from './common';

const NOTE = { save: 'Saved', restore: 'Before restore', version: 'Before version restore' };

const PageRevisionsDrawer = ({ page, onClose, onRestored }) => {
    const { t } = useTranslation();
    const { api } = useSite();
    const [items, setItems] = useState(null);
    const [view, setView] = useState(null); // {rev, html}
    const [busy, setBusy] = useState(false);
    useEffect(() => {
        if (!page) return;
        setItems(null);
        api.get(`/pages/${page.id}/revisions`).then((d) => setItems(d?.items || [])).catch((e) => { toastErr(e); setItems([]); });
    }, [api, page]);
    const show = async (r) => {
        setView({ rev: r, html: null });
        try {
            const rev = await api.get(`/pages/${page.id}/revisions/${r.id}`);
            const pv = await api.post('/preview', { page: { path: page.path, type: page.type, title: rev.title, lang: page.lang, layout: page.layout, content: rev.content } }, { timeout: 60000 });
            setView({ rev: r, html: pv?.html || '' });
        } catch (e) { toastErr(e); setView(null); }
    };
    const restore = async () => {
        setBusy(true);
        try {
            await api.post(`/pages/${page.id}/revisions/${view.rev.id}/restore`);
            message.success(t('Revision restored. Review it, then publish.'));
            setView(null);
            onRestored?.();
            onClose();
        } catch (e) { toastErr(e); } finally { setBusy(false); }
    };
    return (
        <Drawer open={!!page} onClose={onClose} title={`${t('Revisions')}${page ? ` · ${page.title || page.path}` : ''}`} width={420} destroyOnHidden>
            {items === null ? <Spin /> : !items.length ? <Empty description={t('No revisions yet')} /> : (
                <List dataSource={items} renderItem={(r) => (
                    <List.Item actions={[<Button key="v" size="small" onClick={() => show(r)}>{t('View')}</Button>]}>
                        <List.Item.Meta title={fmtDate(r.created_at)} description={<><Tag>{t(NOTE[r.note] || 'Saved')}</Tag><Typography.Text type="secondary">{r.by || ''}</Typography.Text></>} />
                    </List.Item>
                )} />
            )}
            <Modal open={!!view} width={980} onCancel={() => setView(null)} title={view ? fmtDate(view.rev.created_at) : ''} okText={t('Restore')} onOk={restore}
                okButtonProps={{ disabled: !view?.html && view?.html !== '' }} confirmLoading={busy} destroyOnHidden>
                {view && (view.html === null ? <div style={{ padding: 40, textAlign: 'center' }}><Spin /></div> : (
                    <iframe title="revision" sandbox="" srcDoc={view.html} style={{ width: '100%', height: '65vh', border: '1px solid var(--ant-color-border-secondary, #f0f0f0)', borderRadius: 6, background: '#fff' }} />
                ))}
            </Modal>
        </Drawer>
    );
};

export default PageRevisionsDrawer;
